import { isLastDayOfMonth } from 'date-fns';

import { formatDate, formatDateTime, formatTime } from '../../util/DateUtil';
import InvoiceDetailsStore from '../InvoiceDetailsStore';
import { InvoiceLineUsageRow } from '../models/InvoiceLineUsageRow';

export default class InvoiceLineUsagesTableViewStore {
  constructor(private invoiceDetailsStore: InvoiceDetailsStore) {}

  public getDateTime(row: InvoiceLineUsageRow): string {
    const timestamp = new Date(row.timestamp);
    if (formatTime(row.timestamp) === '00:00' && !row.bNumber) {
      return formatDate(timestamp);
    }
    if (formatTime(row.timestamp) === '23:59' && isLastDayOfMonth(timestamp)) {
      return '';
    }
    return formatDateTime(timestamp);
  }

  public getDurationOrVolume(row: InvoiceLineUsageRow): string {
    if (!row.bNumber) {
      return '';
    }
    if (row.duration === '00:00:00') {
      return this.invoiceDetailsStore.formatAsQuantity(row.volume ? +row.volume : 1);
    }
    return row.duration;
  }

  public getDescription(row: InvoiceLineUsageRow): string {
    if (row.serviceDescription) {
      return row.serviceDescription;
    }
    let description = row.bNumber;
    description = InvoiceLineUsagesTableViewStore.addSourceNetworkIfExists(row, description);
    description = InvoiceLineUsagesTableViewStore.addDestinationNetworkIfExists(row, description);
    return description;
  }

  private static addDestinationNetworkIfExists(row: InvoiceLineUsageRow, description: string): string {
    const destinationNetwork = row.destinationNetwork;
    const sourceNetworkOrCountryCode = row.sourceNetwork || row.sourceCountryCode;
    if (destinationNetwork) {
      description += `${sourceNetworkOrCountryCode ? ' >' : ''} ${destinationNetwork}`;
    }
    if (row.destinationCountryCode) {
      description += `${sourceNetworkOrCountryCode && !destinationNetwork ? ' >' : ''} (${row.destinationCountryCode})`;
    }
    return description;
  }

  private static addSourceNetworkIfExists(row: InvoiceLineUsageRow, description: string): string {
    if (row.sourceNetwork) {
      description += ` ${row.sourceNetwork}`;
    }
    if (row.sourceCountryCode) {
      description += ` (${row.sourceCountryCode})`;
    }
    return description;
  }
}
